import React, { useState } from 'react';
import SwipeableViews from 'react-swipeable-views';
import { autoPlay } from 'react-swipeable-views-utils';
import './CaruselText.scss';
import Pagination from './Pagination';
//import { width } from "window-size";

const AutoPlaySwipeableViews = autoPlay(SwipeableViews);

const styles = {
  root: {
    position: 'relative',
    marginBottom: '35px',
    width: '100%',
  },
  slide: {
    padding: 15,
    minHeight: 150,
    color: '#fff',
  },
  /*slide1: {
    backgroundColor: "#FEA900"
  },
  slide2: {
    backgroundColor: "#B3DC4A"
  },
  slide3: {
    backgroundColor: "#6AC0FF"
  }*/
};

function CaruselText() {
  const [index = 0, setIndex] = useState();

  const handleChangeIndex = index => {
    setIndex(index);
  };

  return (
    <div style={styles.root} className="text-container">
      <AutoPlaySwipeableViews
        interval={14000}
        index={index}
        onChangeIndex={handleChangeIndex}
      >
        <div className="CaruselText">
          {/* <h2></h2> */}
          <p className="text-Slider_lp">
            Al anunciarte en Contacta Abogado®, puedes publicar información
            relevante sobre tu experiencia profesional, áreas de especialidad,
            educación, casos de éxito, videos informativos y cursos.
          </p>
          <p className="text-Slider_lp"></p>
        </div>
        <div className="CaruselText">
          {/* <h2></h2> */}
          <p className="text-Sub_p">
            Revolucionamos la manera en la que las personas contratan servicios
            legales.
          </p>
          <p className="text-Sub_p1">
            Entendemos que los hábitos de compra evolucionan con el paso de los
            años, es por eso que queremos ayudarte a posicionar tus servicios en
            línea.
          </p>
        </div>
        <div className="CaruselText">
          {/* <h2></h2> */}
          <p className="text-Sub_p2">
            Contacta Abogado conecta servicios legales, con personas en busca de
            asesoría legal.
          </p>
          <p className="text-Sub_p1">
            Destacar entre otros profesionales es esencial para que los usuarios
            te elijan.
          </p>
        </div>
      </AutoPlaySwipeableViews>
      <Pagination dots={3} index={index} onChangeIndex={handleChangeIndex} />
    </div>
  );
}

export default CaruselText;
